import HTTP from "@/_helpers/http";
import { EMAILCONFIG__API } from "@/_helpers/urls";
import { EMAILCONFIG__MUTATIONS } from "../mutation-types";
import { EMAILCONFIG__ACTIONS } from "../action-types";
import toast from "@/services/Notification";

// State
const state = {
  email_config: null,
};

//Getters
const getters = {};

//Mutations
const mutations = {
  [EMAILCONFIG__MUTATIONS.EMAILCONFIG](state, data) {
    state.email_config = data;
  },
};
// Actions
const actions = {
  async [EMAILCONFIG__ACTIONS.EMAILCONFIG]({ commit, state }) {
    try {
      const url = `${EMAILCONFIG__API.EMAILCONFIG}`;
      const response = await HTTP().get(url);
      commit(EMAILCONFIG__MUTATIONS.EMAILCONFIG, response.data);
    } catch (error) {
      console.log(error);
    }
  },

  async [EMAILCONFIG__ACTIONS.UPDATEEMAILCONFIG]({ dispatch }, parameter) {
    try {
      const params = {
        contact: parameter?.contact || "",
        deposit_from: parameter?.deposit_from || "",
        deposit_to: parameter?.deposit_to || "",
        withdraw_from: parameter?.withdraw_from || "",
        withdraw_to: parameter?.withdraw_to || "",
        account_opening: parameter?.account_opening || "",
        inttxt_from: parameter?.inttxt_from || "",
        inttxt_to: parameter?.inttxt_to || "",
        partner_inttxt_from: parameter?.partner_inttxt_from || "",
        partner_inttxt_to: parameter?.partner_inttxt_to || "",
        partner_withdraw_from: parameter?.partner_withdraw_from || "",
        partner_withdraw_to: parameter?.partner_withdraw_to || "",
        ticket_from: parameter?.ticket_from || "",
        ticket_to: parameter?.ticket_to || "",
        support: parameter?.support || "",
        open_trading_account: parameter?.open_trading_account || "",
        open_demo_account: parameter?.open_demo_account || "",
        trading_report: parameter?.trading_report || "",
        birthday: parameter?.birthday || "",
        back_office: parameter?.back_office || "",
        no_reply: parameter?.no_reply || "",
      };

      const parameterString = Object.keys(params)
        .map(key => params[key] != null ? `${key}=${params[key]}` : "")
        .filter(param => param !== "")
        .join("&");

      const response = await HTTP().patch(
        EMAILCONFIG__API.UPDATEEMAILCONFIG +
        (parameterString !== "" ? `?${parameterString}` : "")
      );

      if (response.status === 200) {
        toast.success("Successfully Updated");
        await dispatch(EMAILCONFIG__ACTIONS.EMAILCONFIG);
      }
    } catch (error) {
      console.error("Error updating server config:", error);
    }
  }

};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions,
};
